module.exports = __webpack_public_path__ + "img/hero-lg-2x.935e61d.webp";